import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import qs from "qs";

Vue.config.productionTip = false;

let win = window,
    vw,
    vh,
    keyboardTarget,
    urlParams = win.location.hash.split("?")[1];

urlParams = qs.parse(urlParams);
store.commit("UPDATE_QUERY_PARAMS", urlParams);

win.setPlayerToken = token => {
    return store.commit("UPDATE_QUERY_PARAMS", {
        player_token: token
    });
};

let cb = e => {
    vw = vw || win.innerWidth;
    vh = vh || win.innerHeight;

    if (win.innerHeight < vh && e.type === "focusin") {
        keyboardTarget = e.target;
        store.commit("TOGGLE_KEYBOARD", true);
    } else if (win.innerHeight === vh) {
        if (
            e.type === "resize" &&
            store.state.isKeyboardOpen &&
            keyboardTarget
        ) {
            keyboardTarget.blur();
        } else if (e.type === "focusout") {
            store.commit("TOGGLE_KEYBOARD", false);
            keyboardTarget = null;
        }
    }
};

win.addEventListener("resize", e => {
    setTimeout(() => {
        cb(e);
    }, 300);
});
win.addEventListener("focusin", e => {
    setTimeout(() => {
        cb(e);
    }, 300);
});
win.addEventListener("focusout", e => {
    setTimeout(() => {
        cb(e);
    }, 300);
});
win.addEventListener("orientationchange", () => {
    let landscape = Math.abs(window.orientation) === 90;
    store.commit("SET_LANDSCAPE", landscape);
});

let resizeEvent = new Event("resize"),
    oriEvent = new Event("orientationchange");

win.dispatchEvent(resizeEvent);
win.dispatchEvent(oriEvent);

if (urlParams.platform === "android") {
    let initAndroidBridge = bridge => {
        bridge.init(function(message, responseCallback) {
            responseCallback({
                "Javascript Responds": "Success!"
            });
        });
    };

    if (win.WebViewJavascriptBridge) {
        initAndroidBridge(win.WebViewJavascriptBridge);
    } else {
        document.addEventListener(
            "WebViewJavascriptBridgeReady",
            function() {
                initAndroidBridge(win.WebViewJavascriptBridge);
            },
            false
        );
    }
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
